import { DateFilterType } from '../enums/date-filter-type.enum';
import { TimeUnit } from '../enums/time-unit.enum';

export class CreationDateFilter {
    from?: Date;
    to?: Date;
    type?: DateFilterType;
    unit?: TimeUnit;
    value?: number;
}
